import { FC, RefObject } from 'react';
import { SkillAncestries, SkillAncestriesId } from '../../models/SkillAncestries';
import SingleUnitSupportSkillsCard from './SingleUnitSupportSkillsCard';
import { Skill } from '../../models/Skill';
import { TieredMenu } from 'primereact/tieredmenu';
import { MenuItem } from 'primereact/menuitem';
interface Props {
  skillAncestries: SkillAncestries[];
  skillTypeUnit: Skill[];
  tieredMenuRef: RefObject<TieredMenu>;
  setItemsTieredMenu: (i: MenuItem[]) => void;
  targetSkillsIds: string[];
}

const SingleUnitSupportSkillsContainer: FC<Props> = ({
  skillTypeUnit,
  skillAncestries,
  tieredMenuRef,
  setItemsTieredMenu,
  targetSkillsIds,
}) => {
  const mediumRelevance = skillAncestries.filter(skill => skill.skillRelevance.id === SkillAncestriesId.MEDIUM);
  const highRelevance = skillAncestries.filter(skill => skill.skillRelevance.id === SkillAncestriesId.HIGH);

  return (
    <div className="flex flex-column gap-lg align-items-center">
      {highRelevance && (
        <SingleUnitSupportSkillsCard
          skillTypeUnit={skillTypeUnit}
          arrayRelevance={highRelevance}
          nameRelevance="Essential"
          tieredMenuRef={tieredMenuRef}
          setItemsTieredMenu={setItemsTieredMenu}
          targetSkillsIds={targetSkillsIds}
        />
      )}
      {mediumRelevance && (
        <SingleUnitSupportSkillsCard
          skillTypeUnit={skillTypeUnit}
          arrayRelevance={mediumRelevance}
          nameRelevance="Helpful"
          tieredMenuRef={tieredMenuRef}
          setItemsTieredMenu={setItemsTieredMenu}
          targetSkillsIds={targetSkillsIds}
        />
      )}
    </div>
  );
};

export default SingleUnitSupportSkillsContainer;
